"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefix = "--bui";
var responsiveStyles = function (
// Object with responsive values
value, variableName, propertyName, formatValue) {
    var _a;
    if (value === undefined)
        return {};
    var spacingPrefix = function (value) {
        return typeof value === "number" ? "_spaced" : "";
    };
    if (typeof value !== "object") {
        var formattedValue = formatValue ? formatValue(value) : value;
        return _a = {},
            _a["".concat(prefix, "_").concat(variableName).concat(spacingPrefix(formattedValue), "_").concat(propertyName, "--s")] = formattedValue,
            _a;
    }
    var viewports = Object.keys(value);
    var responsiveStyles = viewports.reduce(function (acc, key) {
        var formattedValue = formatValue && value ? formatValue(value[key]) : value[key];
        if (formattedValue !== undefined)
            acc["".concat(prefix, "_").concat(variableName).concat(spacingPrefix(formattedValue), "_").concat(propertyName, "--").concat(key)] = formattedValue;
        return acc;
    }, {});
    return responsiveStyles;
};
exports.default = responsiveStyles;
